import { parse } from 'qs';
import { useEffect, useState } from 'react';
import { useDeviceSelectors } from 'react-device-detect';

export interface DeviceDetect {
  isMobile: boolean;
  isDesktop: boolean;
}

export function useDeviceDetect(): DeviceDetect {
  const [selectors, data] = useDeviceSelectors(window.navigator.userAgent);
  const [isMobile, setIsMobile] = useState(selectors.isMobile);
  useEffect(() => {
    const query = parse(window.location.search, { ignoreQueryPrefix: true });
    if (!query.isMobile) return;

    setIsMobile(query.isMobile === 'true');
  }, []);

  return {
    isMobile,
    isDesktop: !isMobile,
  };
}

export default useDeviceDetect;
